import { render, staticRenderFns } from "./solution.vue?vue&type=template&id=fcc85482&scoped=true"
import script from "./solution.vue?vue&type=script&lang=js"
export * from "./solution.vue?vue&type=script&lang=js"
import style0 from "./solution.vue?vue&type=style&index=0&id=fcc85482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc85482",
  null
  
)

export default component.exports